// import reportGwzxList from '../components/reportGwzx/reportGwzxList.vue'
// import addReportGwzx from '../components/reportGwzx/addReportGwzx.vue'
// import viewReportGwzx from '../components/reportGwzx/viewReportGwzx.vue'

export default [
    {
        path: 'reportGwzx/reportGwzxList',
        component: resolve => require(['@/components/reportGwzx/reportGwzxList'],resolve),
        name:"ReportGwzxList",
        meta:{
            id:'639',
            node:'reportGwzx',
            url:'reportGwzxList',
        }
    },
    {
        path: 'reportGwzx/addReportGwzx',
        component: resolve => require(['@/components/reportGwzx/addReportGwzx'],resolve),
        name:"AddReportGwzx",
        meta:{
            // id:'641',
            node:'reportGwzx',
            url:'addReportGwzx',
        }
    },
    {
        path: 'reportGwzx/viewReportGwzx',
        component: resolve => require(['@/components/reportGwzx/viewReportGwzx'],resolve),
        name:"ViewReportGwzx",
        meta:{
            // id:'641',
            node:'reportGwzx',
            url:'viewReportGwzx',
        }
    },
]


// WEBPACK FOOTER //
// ./src/router/reportGwzx.js